
@if (loaderType === loaderTypes.GLOBAL) {
  <div class="overlay">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
} @else {
  @if (localSpinnerloading) {
    <div class="loader w-100">
      <div class="content flex-all-center flex-column">
        <span class="loader-icon spinner-border spinner-border-sm mr-1"></span>
      </div>
    </div>
  }
}
